import { useCallback } from "react";
import { NavigateFunction, NavigateOptions, useNavigate } from "react-router-dom";
import { TVRouter } from "./TVRouter";

const useAppNavigation = () => {
  const _navigate = useNavigate();

  const navigate: NavigateFunction = useCallback(
    (to, opts?) => {
      if (typeof to === "number") {
        _navigate(to);
      } else {
        _navigate(to, opts as NavigateOptions);
      }
    },
    [_navigate],
  );

  const goBack = useCallback(() => {
    const isDeepLink = TVRouter.history
      ? TVRouter.history.length === 1
      : window.history.length === 1;

    if (isDeepLink) {
      _navigate("/catalog");
    } else {
      _navigate(-1);
    }
  }, [_navigate]);
  return { goBack, navigate };
};
export { useAppNavigation };
